import axios from 'axios';
import { $fetch } from '@/utils/fetch';

export interface UploadOptions {
  onProgress?: (progress: number) => void;
  signal?: AbortSignal;
}

const getUploadSignature = async (contentType: string) => {
  const { isSuccess, data } = await $fetch('/oss/v1/credential', {
    data: {
      contentType,
    },
  });

  return { isSuccess, data };
};

const uploadFile = async (file: File, options: UploadOptions = {}) => {
  const { isSuccess, data } = await getUploadSignature(file.type);

  if (!isSuccess) {
    return {
      isSuccess: false,
      msg: '无权上传文件！',
    };
  }

  const formData = new FormData();

  formData.append('key', data.key);
  formData.append('OSSAccessKeyId', data.accessId);
  formData.append('policy', data.policy);
  formData.append('signature', data.signature);
  formData.append('success_action_status', '200');
  formData.append('file', file);

  try {
    const response = await axios.post(`https://${data.host}`, formData, {
      signal: options.signal,
      onUploadProgress: (e) => {
        if (e.total) {
          options.onProgress?.((e.loaded / e.total) * 100);
        }
        else {
          options.onProgress?.(100);
        }
      },
    });

    const status = response.status;

    if (status !== 200) {
      return {
        isSuccess: false,
        msg: '上传失败！',
      };
    }

    return {
      isSuccess: true,
      msg: '上传成功！',
      url: `${data.url}/${data.key}`,
    };
  }
  catch (error: any) {
    if (axios.isCancel(error)) {
      return {
        isSuccess: false,
        msg: '上传已取消',
      };
    }
    else if (error.response) {
      return {
        isSuccess: false,
        msg: '网络错误: ' + error.response.status,
      };
    }
    else {
      return {
        isSuccess: false,
        msg: '图片上传错误: ' + error.message,
      };
    }
  }
};

export default function useUploader() {
  return {
    uploadFile,
    getUploadSignature,
  };
}
